module.exports = __webpack_public_path__ + "media/顏人中 - 不捨（電影《我要我們在一起》推廣曲）『我們都不配擁有另一個自我，分開比依偎的思念更執著。』【動態歌詞Lyrics】.45b3581a.mp3";